export const GET_JOURNAL = 'GET_JOURNAL';
